import { Route } from 'types/route.type';
import BenchmarkAnalytics from './benchmark-analytics';
import { routes as growthRoutes } from './features/growth/routes';

export const routes: Route[] = [
  ...growthRoutes,
  {
    path: '/benchmark-analytics/placeholder-one',
    component: BenchmarkAnalytics,
  },
  {
    path: '/benchmark-analytics/placeholder-two',
    component: BenchmarkAnalytics,
  },
];